"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insurance = void 0;
var internal_1 = require("./internal");
var base_1 = require("./base");
var typeform_1 = require("./typeform");
var tally_1 = require("./tally");
var stagingPrefix = process.env.REACT_APP_ENV === 'staging' ? 'staging.' : '';
exports.insurance = {
    healthInsurance: {
        miniJobThreshold: 556,
        privateHealthInsuranceThreshold: 6150, // (73_800 / 12 = 6_150, see below) The threshold to reach in order to qualify for private health as an employee
    },
    household: {
        signup: "".concat(base_1.appURL, "/policies/household"),
        landingPage: "".concat(base_1.websiteURL, "/household-insurance"),
        regionalLandingPage: "".concat(base_1.websiteURL, "/:region/household-insurance"),
        policyDetail: "".concat(internal_1.contentBucketUrl, "/legal/household-insurance/policy-detail.pdf"),
        policyStatement: "".concat(internal_1.contentBucketUrl, "/legal/household-insurance/IPID.pdf"),
        price: 2.5,
    },
    publicHealth: {
        landingPage: "".concat(base_1.websiteURL, "/health-insurance/public"),
        landingPageTK: "".concat(base_1.websiteURL, "/health-insurance/public/tk"),
        minCappedIncome: 1300,
        tk: (0, base_1.getBrokerURLs)('tk'),
        aok: (0, base_1.getBrokerURLs)('aok'),
        barmer: (0, base_1.getBrokerURLs)('barmer'),
        dak: (0, base_1.getBrokerURLs)('dak'),
        bkk: {
            signup: "".concat(base_1.appURL, "/policies/public-health-bkk-firmus"),
        },
    },
    privateHealth: {
        signup: base_1.privateURL,
        landingPage: "".concat(base_1.websiteURL, "/health-insurance/private"),
        dataProtection: "".concat(internal_1.contentBucketUrl, "/legal/private-health-insurance/hallesche/DATA%20protection.pdf"),
        schufa: "".concat(internal_1.contentBucketUrl, "/legal/private-health-insurance/misc/SCHUFA%20english.pdf"),
        disclosureObligation: "".concat(internal_1.contentBucketUrl, "/legal/private-health-insurance/hallesche/Inormation%20of%20the%20Consequences%20of%20the%20Violation%20of%20the%20Disclosure%20Obligation.pdf"),
        preSignup: "".concat(base_1.appURL, "/policies/private-health"),
        freelancerThresholdUnder51: 36000,
        freelancerThreshold51OrOlder: 51000,
        passiveIncomeThreshold: 60000,
        employeeThreshold: 73800, // (12 * 6_150 = 73_800 see above)
    },
    legal: {
        signup: "".concat(base_1.appURL, "/policies/legal"),
        landingPage: "".concat(base_1.websiteURL, "/legal-insurance"),
        policyDetail: "".concat(internal_1.contentBucketUrl, "/legal/legal-insurance/roland/Terms_of_Service_general.pdf"),
        price: 17.06,
    },
    expathHealth: {
        signup: "".concat(base_1.appURL, "/policies/expat"),
        landingPage: "".concat(base_1.websiteURL, "/health-insurance/expat/short-term"),
        regionalLandingPage: "".concat(base_1.websiteURL, "/:region/health-insurance/expat/short-term"),
        policyDetail: "".concat(internal_1.contentBucketUrl, "/legal/expat-insurance/policy-detail.pdf"),
        price: 72,
        deductible: 25,
    },
    expatLongTerm: {
        medicalQuestionnaire: 'https://assets.april.fr/april-international/Products/pdf-Long-Term-Claim+Form-eu.pdf',
    },
    longTermExpatHealth: {
        signup: "".concat(tally_1.tally, "/en-de/international-health"),
        landingPage: "".concat(base_1.websiteURL, "/health-insurance/expat/long-term"),
    },
    liability: {
        signup: "".concat(base_1.appURL, "/policies/liability/quote"),
        landingPage: "".concat(base_1.websiteURL, "/personal-liability-insurance"),
        policyDetail: "".concat(internal_1.contentBucketUrl, "/legal/liability-insurance/FeatherPersonalLiability_IPID_EN.pdf"),
        price: 4.94,
    },
    dental: {
        signup: "".concat(base_1.appURL, "/policies/dental"),
        landingPage: "".concat(base_1.websiteURL, "/dental-insurance"),
        price: 9,
    },
    bike: {
        signup: "".concat(base_1.appURL, "/policies/bike"),
        landingPage: "".concat(base_1.websiteURL, "/bike-insurance"),
        price: 2.9,
    },
    life: {
        signup: "".concat(base_1.appURL, "/policies/life"),
        landingPage: "".concat(base_1.websiteURL, "/life-insurance"),
        regionalLandingPage: "".concat(base_1.websiteURL, "/:region/life-insurance"),
        policyDetail: "".concat(internal_1.contentBucketUrl, "/legal/life-insurance/life-policy-document.pdf"),
        price: 1.98,
    },
    disability: {
        signup: "".concat(base_1.appURL, "/policies/disability"),
        landingPage: "".concat(base_1.websiteURL, "/disability-insurance"),
        price: 50,
    },
    dogLiability: {
        signup: "".concat(base_1.appURL, "/policies/dog-liability"),
        landingPage: "".concat(base_1.websiteURL, "/dog-liability-insurance"),
        price: 5.58,
    },
    professionalLiability: {
        signup: "".concat(typeform_1.typeform.base, "/to/a522ECDj"),
        landingPage: "".concat(base_1.websiteURL, "/professional-liability-insurance"),
        price: 17.75,
    },
    travelHealth: {
        signup: "".concat(base_1.appURL, "/policies/travel-health"),
        landingPage: "".concat(base_1.websiteURL, "/travel-insurance"),
        regionalLandingPage: "".concat(base_1.websiteURL, "/:region/health-insurance/travel"),
    },
    petHealth: {
        signup: "".concat(base_1.appURL, "/policies/pet-health"),
        landingPage: "".concat(base_1.websiteURL, "/pet-health-insurance"),
    },
    pension: {
        signup: "".concat(base_1.appURL, "/policies/pension"),
        landingPage: "".concat(base_1.websiteURL, "/pension-insurance"),
    },
    basisPension: {
        signup: "".concat(tally_1.tally.base, "/basis-pension-sign-up"),
        landingPage: "".concat(base_1.websiteURL, "/pension-insurance/basis"),
    },
    studentHealth: {
        landingPage: "".concat(base_1.websiteURL, "/health-insurance/public/students"),
    },
};
